import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wordsinitials',
  standalone: true
})
export class WordsinitialsPipe implements PipeTransform {

  transform(value: string): string {
    if(value) {
      return (value as string).split(' ').map(word => word.charAt(0).toUpperCase()).join('');
    }
    return '';
  }
}
